import React from 'react';

export const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      text: "They painted and installed vinyl flooring in our condo. Amazing work and great finishing.",
      author: "Homeowner",
      location: "North York",
      rating: 5
    },
    {
      text: "Reliable crew. Completed our office paint and carpet flooring professionally.",
      author: "Office Manager",
      location: "Toronto",
      rating: 5
    },
    {
      text: "Our kitchen cabinets look brand new! Spray finish was fantastic.",
      author: "Client",
      location: "Scarborough",
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-teal-100 rounded-full mb-6">
            <i className="ri-star-line text-teal-600 mr-2"></i>
            <span className="text-sm font-semibold text-teal-700">Testimonials</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real feedback from satisfied customers across the GTA
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-gray-700 text-lg mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              {/* Author */}
              <div className="flex items-center">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.author}</div>
                  <div className="text-sm text-gray-500">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">10+</div>
            <div className="text-gray-600">Years Experience</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
            <div className="text-gray-600">Projects Completed</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
            <div className="text-gray-600">Satisfaction Rate</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">GTA</div>
            <div className="text-gray-600">Service Coverage</div>
          </div>
        </div>
      </div>
    </section>
  );
};
